function sparklesAnim(el) {
  const canvas = document.querySelector(el),
        renderer = new THREE.WebGLRenderer({ canvas, antialias: true })

  const fov = 70,
    aspect = 2,
    near = 0.1,
    far = 2000,
    camera = new THREE.PerspectiveCamera(fov, aspect, near, far),
    scene = new THREE.Scene(),
    clock = new THREE.Clock()

  renderer.setClearColor(0x000000)
  camera.position.z = 10

  let lightTop = new THREE.DirectionalLight(0x0000FF, 1)
  lightTop.position.y = 1
  scene.add(lightTop)

  let lightBottom = new THREE.DirectionalLight(0x00FFD4, 1)
  lightBottom.position.y = -1
  scene.add(lightBottom)

  let lightRight = new THREE.DirectionalLight(0x0000FF, 1)
  lightRight.position.z = 4
  lightRight.position.x = 2
  scene.add(lightRight)

  let mouse = new THREE.Vector2(),
    state = {
      set mouseInViewport(val) {
        material.uniforms.mouseInViewport.value = val
      },
      get mouseInViewport() {
        return material.uniforms.mouseInViewport.value
      },
    },
    raycaster = new THREE.Raycaster()

  function onMouseMove(e) {
    mouse.x = (e.clientX / window.innerWidth) * 2 - 1
    mouse.y = -(e.clientY / window.innerHeight) * 2 + 1
  }

  function onMouseEnter(e) {
    state.mouseInViewport = true
  }

  function onMouseLeave(e) {
    state.mouseInViewport = false
  }

  document.body.addEventListener('mousemove', onMouseMove, false)
  document.body.addEventListener('mouseenter', onMouseEnter, false)
  document.body.addEventListener('mouseleave', onMouseLeave, false)

  let config = {
      color: 'white',
      size: 0.05,
      range: 10,
      count: 2000,
    },
    prefab = new THREE.TetrahedronGeometry(config.size),
    geometry = new BAS.PrefabBufferGeometry(prefab, config.count),
    positionBuffer = geometry.createAttribute('pPosition', 3),
    rotationBuffer = geometry.createAttribute('axisAngle', 4)

  let range = 10,
    axis = new THREE.Vector3(),
    prefabData = []

  for (let i = 0; i < config.count; i++) {
    // Position
    prefabData[0] = THREE.Math.randFloatSpread(config.range)
    prefabData[1] = THREE.Math.randFloatSpread(config.range)
    prefabData[2] = THREE.Math.randFloatSpread(config.range / 8)

    geometry.setPrefabData(positionBuffer, i, prefabData)

    BAS.Utils.randomAxis(axis)
    axis.toArray(prefabData)
    prefabData[3] = Math.PI * 0.4 // Rotation angle

    geometry.setPrefabData(rotationBuffer, i, prefabData)
  }

  geometry.computeVertexNormals()

  let material = new BAS.PhongAnimationMaterial({
    shading: THREE.FlatShading,
    uniforms: {
      time: { value: 0 },
      mouseX: { value: 0 },
      mouseY: { value: 0 },
      mouseIn: { value: false },
      mouseInViewport: { value: false },
    },
    uniformValues: {
      specular: new THREE.Color(0xffffff),
      shininess: 30,
    },
    vertexFunctions: [
      BAS.ShaderChunk['quaternion_rotation'],
      // Map
      `float map(float in_min, float in_max, float out_min, float out_max, float in_value) {
				return (in_value - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
			}`,
      // Simplex noise
      `vec3 permute(vec3 x) { return mod(((x*34.0)+1.0)*x, 289.0); }
			
			float snoise(vec2 v) {
				const vec4 C = vec4(0.211324865405187, 0.366025403784439, -0.577350269189626, 0.024390243902439);
				vec2 i  = floor(v + dot(v, C.yy) );
				vec2 x0 = v -   i + dot(i, C.xx);
				vec2 i1;
				i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0);
				vec4 x12 = x0.xyxy + C.xxzz;
				x12.xy -= i1;
				i = mod(i, 289.0);
				vec3 p = permute( permute( i.y + vec3(0.0, i1.y, 1.0 ))
				+ i.x + vec3(0.0, i1.x, 1.0 ));
				vec3 m = max(0.5 - vec3(dot(x0,x0), dot(x12.xy,x12.xy),
										dot(x12.zw,x12.zw)), 0.0);
				m = m*m ;
				m = m*m ;
				vec3 x = 2.0 * fract(p * C.www) - 1.0;
				vec3 h = abs(x) - 0.5;
				vec3 ox = floor(x + 0.5);
				vec3 a0 = x - ox;
				m *= 1.79284291400159 - 0.85373472095314 * ( a0*a0 + h*h );
				vec3 g;
				g.x  = a0.x  * x0.x  + h.x  * x0.y;
				g.yz = a0.yz * x12.xz + h.yz * x12.yw;
				return 130.0 * dot(m, g);
			}`,
    ],
    vertexParameters: [
      'uniform float time;',
      'uniform float mouseX;',
      'uniform float mouseY;',
      'uniform bool mouseIn;',
      'uniform bool mouseInViewport;',
      'attribute vec3 pPosition;',
      'attribute vec4 axisAngle;',
    ],
    varyingParameters: ['varying float v_intRange;'],
    vertexInit: [
      'vec4 rot = quatFromAxisAngle(axisAngle.xyz, axisAngle.w * exp2(sin(time*.5)));',
    ],
    vertexNormal: ['objectNormal = rotateVector(rot, objectNormal);'],
    vertexPosition: [
      'float interactiveFactor;',
      'vec2 rangeTmp;',
      'float zModifier;',
      'float noise = snoise(vec2(pPosition.xy/5. + time));',
      'zModifier = noise;',
      'if (mouseIn && mouseInViewport) {',
      '	rangeTmp = vec2(mouseX, mouseY) - pPosition.xy;',
      '	rangeTmp = abs(rangeTmp);',
      '	if (rangeTmp.x >= rangeTmp.y) {',
      '		interactiveFactor = rangeTmp.x;',
      '	} else {',
      '		interactiveFactor = rangeTmp.y;',
      '	}',
      '	interactiveFactor = clamp(interactiveFactor, 0., 2.);',
      '	interactiveFactor = 2. - interactiveFactor;',
      '	zModifier *= 1. + interactiveFactor;',
      '}',
      'transformed.z += zModifier;',
      'transformed = rotateVector(rot, transformed);',
      'transformed *= map(-1., 1., 0., 1., noise);',
      'transformed += pPosition;',
      'transformed *= (noise+3.)/4.5;',
      'v_intRange = interactiveFactor;',
    ],
    fragmentDiffuse: [
      'totalEmissiveRadiance.r = v_intRange;',
      'totalEmissiveRadiance.b = v_intRange;',
    ],
  })

  let particles = new THREE.Mesh(geometry, material)
  scene.add(particles)

  let rangeAddition = 4,
    planeSize = config.range + rangeAddition,
    recievingPlane = new THREE.Mesh(
      new THREE.PlaneGeometry(planeSize, planeSize),
      {}
    )
  scene.add(recievingPlane)

  function resizeRendererToDisplaySize(renderer) {
    const canvas = renderer.domElement
    const pixelRatio = window.devicePixelRatio
    const width = (canvas.clientWidth * pixelRatio) | 0
    const height = (canvas.clientHeight * pixelRatio) | 0
    const needResize = canvas.width !== width || canvas.height !== height
    if (needResize) {
      renderer.setSize(width, height, false)
    }
    return needResize
  }

  function render(time) {
    time *= 0.005

    if (state.mouseInViewport) {
      raycaster.setFromCamera(mouse, camera)

      let intersection = raycaster.intersectObject(recievingPlane)

      if (intersection.length) {
        material.uniforms.mouseX.value = intersection[0].point.x
        material.uniforms.mouseY.value = intersection[0].point.y
        material.uniforms.mouseIn.value = true
      } else {
        material.uniforms.mouseX.value = 0
        material.uniforms.mouseY.value = 0
        material.uniforms.mouseIn.value = false
      }
    }

    if (resizeRendererToDisplaySize(renderer)) {
      const canvas = renderer.domElement
      camera.aspect = canvas.clientWidth / canvas.clientHeight
      camera.updateProjectionMatrix()
    }

    material.uniforms.time.value += clock.getDelta() / 20

    renderer.render(scene, camera)

    requestAnimationFrame(render)
  }

  requestAnimationFrame(render)
}

export default sparklesAnim
